// extracted by mini-css-extract-plugin
module.exports = {"c18xye24":"c18xye24"};